// import Article from "./Article";
import React from "react"

import HelloArticleDesktop from "./HelloArticleDesktop"
import HelloArticleMobile from "./HelloArticleMobile"

export default function HelloArticle({ isDesktop, format }) {
  return (
    <>
      {/* {format} */}
      {isDesktop ? HelloArticleDesktop(format) : HelloArticleMobile(format)}
    </>
  )
}
